"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridBodyLayoutFragmentSlot = exports.StyledGridBodyLayoutGridSlot = exports.StyledGridBodyLayoutToolbarSlot = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledGridBodyLayoutToolbarSlot = styled_components_1.default.div `
    display: flex;
    align-self: stretch;
    flex-direction: column;
    flex-shrink: 0;
    min-width: 0;
    min-height: 0;
`;
exports.StyledGridBodyLayoutGridSlot = styled_components_1.default.div `
    display: flex;
    align-self: stretch;
    flex: 1;
    flex-direction: column;
    flex-shrink: 0;
    min-width: 0;
    min-height: 0;
`;
exports.StyledGridBodyLayoutFragmentSlot = styled_components_1.default.div `
    position: absolute;
    top: -9999px;
    left: -9999px;
    visibility: hidden;
`;
//# sourceMappingURL=GridBodyLayout.styles.js.map